export default "images/bg9.jpg";